// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DotChartOutlinedSvg from "@fishx/icons-svg/es/asn/DotChartOutlined";
import FishxIcon from '../components/FishxIcon';

var DotChartOutlined = function DotChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DotChartOutlinedSvg
  }));
};

DotChartOutlined.displayName = 'DotChartOutlined';
export default React.forwardRef(DotChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DotChartOutlined.js
// module id = 2450
// module chunks = 0